import React, { useEffect, useState } from "react";
import i18n from "../../../language/i18n";
import { loadTypeTags, TYPE_TAG_GROUPS, typeTagLabel, TypeTag } from "../../../services/typeTagApi";

type Props = {
  selected: string[];
  onChange: (ids: string[]) => void;
  /** Show only products waiting for a person to confirm their suggested tags. */
  review: boolean;
  onReviewChange: (on: boolean) => void;
  /** With `only`, the sheet title already names the section. */
  showTitle: boolean;
  hidden: boolean;
};

/** Studio product list filter: pieces carrying any chosen type tag. Renders nothing when the server has tags off. */
const TypeTagFilterSection = ({ selected, onChange, review, onReviewChange, showTitle, hidden }: Props) => {
  const [tags, setTags] = useState<TypeTag[] | null | undefined>(undefined);
  useEffect(() => {
    let live = true;
    loadTypeTags().then((rows) => live && setTags(rows));
    return () => {
      live = false;
    };
  }, []);
  if (!tags || !tags.length) return null;
  const language = i18n.language;
  const toggle = (id: string) => onChange(selected.includes(id) ? selected.filter((t) => t !== id) : [...selected, id]);
  return (
    <section className="pl-fgrp" data-section="types" hidden={hidden} aria-label="Type tags">
      <div className="pl-fgrp__h">
        <span>{showTitle ? "Type tags" : ""}</span>
        {selected.length ? <i>{selected.length}</i> : null}
      </div>
      <div className="pl-chips is-wrap">
        <button type="button" aria-pressed={review} className={`pl-chip${review ? " is-on" : ""}`} onClick={() => onReviewChange(!review)}>
          Tags to review
        </button>
      </div>
      {TYPE_TAG_GROUPS.map((g) => {
        const rows = tags.filter((t) => t.group === g.group);
        if (!rows.length) return null;
        return (
          <div key={g.group} className="pl-tag-group">
            <small className="pl-tag-group__label">{g.label}</small>
            <div className="pl-chips is-wrap">
              {rows.map((tag) => {
                const on = selected.includes(tag.id);
                return (
                  <button
                    key={tag.id}
                    type="button"
                    aria-pressed={on}
                    className={`pl-chip${on ? " is-on" : ""}`}
                    onClick={() => toggle(tag.id)}
                  >
                    {typeTagLabel(tag, language)}
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default TypeTagFilterSection;
